import React from "react";
import useDeviceType from "../../Utils/useDeviceType";
import CourseListPC from "./PC";
import CourseListMobile from "./Mobile";
import { useHeaderProps } from "../../components/Layouts/SubLayout/useHeaderProps";
function Index() {
    const { isPC } = useDeviceType();

    useHeaderProps({ title: "我的课程" });

    return (
        <div>
            {isPC && <CourseListPC />}
            {!isPC && <CourseListMobile />}
        </div>
    );
}

export default Index;
